import { ThermReading } from "./ThermReading";
import { Reading } from "./Reading";

export class SmokeSummary
{
    SmokeID: string = "";
    Description: string = "";

    Strength: number = 0;
    Ambient: number = 0;

    m_thermReadings: Map<number, ThermReading> = new Map<number, ThermReading>();

    get AllThermReadings(): ThermReading[]
    {
        return Array.from(this.m_thermReadings.values());
    }

    thermReadings(thermID: number | string): Reading[]
    {
        if (typeof thermID === "string")
            thermID = parseInt(thermID);

        return this.m_thermReadings.get(thermID)?.Readings ?? [];
    }

    addReading(thermID: number, reading: Reading)
    {
        let thermReading = this.m_thermReadings.get(thermID);

        if (!thermReading)
        {
            thermReading = new ThermReading();

            thermReading.ThermID = thermID;
            thermReading.Strength = reading.SignalStrength;

            this.m_thermReadings.set(thermID, thermReading);
        }

        thermReading.Readings.push(reading);
    }
}